// TODO storeのnameとpreserve-stateをまとめて一元管理できるようにする
export const PRESERVED_STATE_SESSION_PATHS = ['analytics', 'auth', 'cognito', 'myBuildings', 'myCurrentBuilding', 'myDevice', 'staticAssets']
export const PRESERVED_STATE_LOCAL_PATHS = ['localParamStorage']
